'use client';

import { useMemo } from 'react';
import type { TestingInstructionsTargetKind } from '@terra/ui-design-system';
import { useAppTargetId, useProjectStore } from '../../../store/projectStore';
import { TARGET_TYPE } from '../../../utils/target-scope.utils';

export type TestingControlsApplicationScope = {
  applicationId: string;
  targetKind: Extract<
    TestingInstructionsTargetKind,
    'web-application' | 'ai-application'
  >;
};

export const useTestingControlsApplicationScope =
  (): TestingControlsApplicationScope | null => {
    const applicationId = useAppTargetId();
    const tenantId = useProjectStore(
      (state) => state.selectedCompany?.tenantId,
    );
    const isAiApplication = useProjectStore(
      (state) => state.targetType === TARGET_TYPE.AI_APPLICATION,
    );

    return useMemo(
      () =>
        applicationId && tenantId
          ? {
              applicationId,
              targetKind: isAiApplication
                ? 'ai-application'
                : 'web-application',
            }
          : null,
      [applicationId, isAiApplication, tenantId],
    );
  };
